import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'

import { Container } from '@/components/shared/Container'

import { DatoImage } from '@/elements/global/DatoImage'

import { trackCtaClick } from '@/lib/gtm/gtmV2'

type ImageRecord = {
  id?: string
  imageStyle?: string
  addLink?: boolean
  linkUrl?: string
  openInNewTab?: boolean
  gtmEvent?: string
  gtmCta?: string
  image: { responsiveImage: any }
}

const imageStylesMap = {
  Narrow: 'narrow',
  Medium: 'normal',
  Full: 'wide',
} as const

const StyledImage = styled.div`
  margin-top: 50px;
  margin-bottom: 56px;
  img {
    border-radius: 4px;
  }
  figcaption {
    margin-top: 16px;
    text-align: center;
    color: ${(props) => props.theme.colours.secondary};
    font: 16px;
    line-height: 26px;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    figcaption {
      margin-top: 8px;
      font: 14px;
      line-height: 24px;
    }
  }
  figure {
    margin: 0;
  }
`

export const ImageBlock = ({ record }: { record: ImageRecord }) => {
  const containerSize = record.imageStyle !== undefined ? imageStylesMap[record.imageStyle] : 'narrow'
  const router = useRouter()

  const linkClickHandler = () => {
    if (record.gtmCta) {
      trackCtaClick('cms', record.gtmCta)
    }
  }

  return (
    <Container $size={containerSize}>
      <StyledImage>
        <figure className={`${record.imageStyle}`}>
          {record.linkUrl ? (
            <Link
              href={record.linkUrl}
              {...(record.openInNewTab && { target: '_blank' })}
              onClick={linkClickHandler}
              passHref
            >
              <DatoImage data={record.image.responsiveImage} />
            </Link>
          ) : (
            <DatoImage data={record.image.responsiveImage} />
          )}
          {record.image.responsiveImage.title ? <figcaption>{record.image.responsiveImage.title}</figcaption> : ''}
        </figure>
      </StyledImage>
    </Container>
  )
}
